import { render, staticRenderFns } from "./totalfowAccounts.vue?vue&type=template&id=504cde6f&scoped=true&"
import script from "./totalfowAccounts.vue?vue&type=script&lang=js&"
export * from "./totalfowAccounts.vue?vue&type=script&lang=js&"
import style0 from "./totalfowAccounts.vue?vue&type=style&index=0&id=504cde6f&prod&lang=scss&scoped=true&"
import style1 from "./totalfowAccounts.vue?vue&type=style&index=1&id=504cde6f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504cde6f",
  null
  
)

export default component.exports